import { createSlice } from '@reduxjs/toolkit';

const filtersSlice = createSlice({
  name: 'filters',
  initialState: {
    categoryId: null,
    categoryName: 'All',
    minPrice: '',
    maxPrice: '',
    sortBy: '-created_at',
    searchQuery: '',
    inStockOnly: false,
    page: 1,
    pageSize: 12,
    // Current page of the category / sub-category / discount listings, keyed per
    // listing (e.g. 'category:4'), so returning from a product page keeps it
    listPages: {},
  },
  reducers: {
    setCategory: (state, action) => {
      const { id, name } = action.payload;
      state.categoryId = id;
      state.categoryName = name || 'All';
      state.page = 1;
    },
    setMinPrice: (state, action) => {
      state.minPrice = action.payload;
      state.page = 1;
    },
    setMaxPrice: (state, action) => {
      state.maxPrice = action.payload;
      state.page = 1;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
      state.page = 1;
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
      state.page = 1;
    },
    setInStockOnly: (state, action) => {
      state.inStockOnly = action.payload;
      state.page = 1;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setListPage: (state, action) => {
      const { key, page } = action.payload;
      state.listPages[key] = page;
    },
    clearFilters: (state) => {
      state.categoryId = null;
      state.categoryName = 'All';
      state.minPrice = '';
      state.maxPrice = '';
      state.sortBy = '-created_at';
      state.searchQuery = '';
      state.inStockOnly = false;
      state.page = 1;
    },
  },
});

export const {
  setCategory,
  setMinPrice,
  setMaxPrice,
  setSortBy,
  setSearchQuery,
  setInStockOnly,
  setPage,
  setListPage,
  clearFilters,
} = filtersSlice.actions;

export const selectFilters = (state) => state.filters;
export const selectCategoryName = (state) => state.filters.categoryName;
export const selectSortBy = (state) => state.filters.sortBy;
export const selectSearchQuery = (state) => state.filters.searchQuery;
export const selectInStockOnly = (state) => state.filters.inStockOnly;
export const selectPage = (state) => state.filters.page;
export const selectListPage = (state, key) => state.filters.listPages[key] || 1;

export default filtersSlice.reducer;
